import { render, staticRenderFns } from "./FooterPage.vue?vue&type=template&id=4c9e4ca3&scoped=true"
import script from "./FooterPage.vue?vue&type=script&lang=js"
export * from "./FooterPage.vue?vue&type=script&lang=js"
import style0 from "./FooterPage.vue?vue&type=style&index=0&id=4c9e4ca3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9e4ca3",
  null
  
)

export default component.exports